import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PlayerCard from '../../cards/PlayerCard';
import { getRatingDetails, setRatingChoice } from '../../../utils';
import { ComparatorTypes, comparator } from '../../../utils/comparator';
import { SortType } from '../../ColumnHeader';

import styles from './playersListSortable.scss';

const List = props => {
    const { players, auth, sortParam, sortType } = props;

    const [sortedList, setSortedList] = useState(players);

    useEffect(() => {
        setSortedList(players);
    }, [players]);

    let singlesRating;
    let doublesRating;

    const getPlayerSortValue = (player, sortPrm) => {
        switch (sortPrm) {
            case 'singlesRating':
                singlesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'singles' }), auth.user.subscriptionType);
                return singlesRating.actualValue;
            case 'doublesRating':
                doublesRating = getRatingDetails(setRatingChoice({ player, ratingType: 'doubles' }), auth.user.subscriptionType);
                return doublesRating.actualValue;
            default:
                return player[sortPrm];
        }
    };

    const getComparatorType = (sortPrm) => {
        return sortPrm === 'singlesRating' || sortPrm === 'doublesRating' ? ComparatorTypes.NUMBER : ComparatorTypes.STRING;
    };

    const getComparatorArguments = (sortPrm, sortTp) => {
        const args = [];
        const primarySortArg = {
            type: getComparatorType(sortPrm),
            field: 'primarySortValue',
            descend: sortTp === SortType.DESC,
        };
        args.push(primarySortArg);
        if (sortPrm === 'name') {
            const secondarySortArg = {
                type: getComparatorType(sortPrm),
                field: 'secondarySortValue',
                descend: sortTp === SortType.DESC,
            };
            args.push(secondarySortArg);
        }
        return args;
    };

    useEffect(() => {
        sortedList.forEach((player) => {
            if (sortParam === 'name') {
                player.primarySortValue = getPlayerSortValue(player, 'lastName');
                player.secondarySortValue = getPlayerSortValue(player, 'firstName');
            } else {
                player.primarySortValue = getPlayerSortValue(player, sortParam);
            }
        });
        const arr = [...sortedList];
        arr.sort(comparator(getComparatorArguments(sortParam, sortType)));
        setSortedList(arr);
    }, [sortParam, sortType]);

    return (
        <div className={`${styles.listContainer}`}>
            <div data-test="card-list">
                {sortedList && sortedList.length > 0 && sortedList.map((player, i) => (
                    <PlayerCard
                        key={`player-${i}`}
                        player={{
                            ...player,
                            id: player.playerId,
                            playerProfileImages: player.profileImage || {},
                        }}
                        subscriptionType={auth.user.subscriptionType}
                    />
                ))}
            </div>
        </div>
    );
};

List.propTypes = {
    players: PropTypes.instanceOf(Array).isRequired,
    auth: PropTypes.instanceOf(Object).isRequired,
    sortParam: PropTypes.string.isRequired,
    sortType: PropTypes.string.isRequired,
};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(List);
